import type { RTCSession } from 'jssip/lib/RTCSession';

import { SessionStatus } from 'features/sip/enums';
import type { RtcConnection } from 'features/sip/interfaces';

export const isRtcConnectionActive = (
  rtcConnection: RtcConnection
): boolean => {
  if (
    rtcConnection.connectionState === 'closed' ||
    rtcConnection.connectionState === 'disconnected'
  ) {
    console.log('DEBUG: RTC connection is in closed or disconnected state.');
    return false;
  }

  return true;
};

export const isRtcSessionTerminated = (
  rtcSession: RTCSession | null
): boolean => {
  return !rtcSession || rtcSession.status === SessionStatus.STATUS_TERMINATED;
};
